import { render, staticRenderFns } from "./Question_G.vue?vue&type=template&id=3fe64fc4&scoped=true"
import script from "./Question_G.vue?vue&type=script&lang=js"
export * from "./Question_G.vue?vue&type=script&lang=js"
import style0 from "./Question_G.vue?vue&type=style&index=0&id=3fe64fc4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fe64fc4",
  null
  
)

export default component.exports